module.exports = __webpack_public_path__ + "img/teaser_pferd9.32983a7c.jpg";